export default "<router-outlet></router-outlet>\r\n<!--<app-footer></app-footer>-->\r\n"